var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12" }, [
        _c("section", { staticClass: "card" }, [
          _vm._m(1),
          _c("div", { staticClass: "card-body" }, [
            _vm.loadingRollCallCountHistoryCurrent
              ? _c("div", [_c("a-spin", { attrs: { tip: "Loading..." } })], 1)
              : _c(
                  "div",
                  _vm._l(_vm.rollCallCountHistoryCurrent, function(
                    plan,
                    index
                  ) {
                    return _c("div", { key: index }, [
                      Object.keys(plan.roll_call_count).length > 0
                        ? _c(
                            "div",
                            { staticStyle: { "margin-bottom": "40px" } },
                            [
                              _c(
                                "h3",
                                { staticStyle: { "margin-bottom": "10px" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.planName[plan.plan]) + " プラン"
                                  )
                                ]
                              ),
                              _vm._l(plan.roll_call_count, function(
                                roll_call_count,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticStyle: {
                                      "margin-left": "25px",
                                      "margin-bottom": "10px"
                                    }
                                  },
                                  [
                                    _c(
                                      "h5",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "5px",
                                          "margin-top": "10px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "契約コール数 " +
                                            _vm._s(index) +
                                            "回: " +
                                            _vm._s(roll_call_count.count) +
                                            "人"
                                        )
                                      ]
                                    ),
                                    _vm.agentRollCallAddAuto === 2
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            roll_call_count.added,
                                            function(added, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticStyle: {
                                                    "margin-left": "50px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        "margin-bottom": "0"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "・追加コール数 " +
                                                          _vm._s(index) +
                                                          "回: " +
                                                          _vm._s(added) +
                                                          "人"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e()
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  }),
                  0
                )
          ])
        ])
      ]),
      _c("div", { staticClass: "col-lg-12" }, [
        _c("section", { staticClass: "card" }, [
          _vm._m(2),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c(
                "a-config-provider",
                { attrs: { locale: _vm.locale } },
                [
                  _c(
                    "a-form",
                    {
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: { layout: "inline" }
                    },
                    [
                      _vm._v("\n              対象月：\n              "),
                      _c("a-month-picker", {
                        staticStyle: { width: "30%" },
                        attrs: { value: _vm.currentMonth },
                        on: { change: _vm.targetMonthChange }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.loadingRollCallCountHistory
                ? _c(
                    "div",
                    { staticClass: "text-center" },
                    [_c("a-spin", { attrs: { tip: "Loading..." } })],
                    1
                  )
                : _vm._e(),
              !_vm.loadingRollCallCountHistory
                ? _c(
                    "div",
                    [
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columnsRollCallCountHistory,
                          "data-source": _vm.rollCallCountHistory,
                          rowKey: "id",
                          rowClassName: function(r, i) {
                            return i % 2 === 0
                              ? _vm.$style.stripe1
                              : _vm.$style.stripe0
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "user_name",
                              fn: function(id, record) {
                                return _c(
                                  "span",
                                  {},
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "userShow",
                                            params: { id: record.user_id }
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(record.user_name))]
                                    )
                                  ],
                                  1
                                )
                              }
                            },
                            {
                              key: "plan",
                              fn: function(plan) {
                                return _c("span", {}, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.planName[plan]) +
                                      "\n              "
                                  )
                                ])
                              }
                            },
                            {
                              key: "roll_call_count",
                              fn: function(roll_call_count) {
                                return _c("span", {}, [
                                  _vm._v(_vm._s(roll_call_count))
                                ])
                              }
                            },
                            {
                              key: "roll_call_count_used",
                              fn: function(roll_call_count_used) {
                                return _c("span", {}, [
                                  _vm._v(_vm._s(roll_call_count_used))
                                ])
                              }
                            },
                            {
                              key: "roll_call_count_added",
                              fn: function(id, record) {
                                return _c("span", {}, [
                                  _vm.agentRollCallAddAuto === 1
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            record.roll_call_count_used -
                                              record.roll_call_count >
                                              0
                                              ? record.roll_call_count_used -
                                                  record.roll_call_count
                                              : 0
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm.agentRollCallAddAuto === 2
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            record.roll_call_count_max -
                                              record.roll_call_count >
                                              0
                                              ? record.roll_call_count_max -
                                                  record.roll_call_count
                                              : 0
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              }
                            }
                          ],
                          null,
                          false,
                          1216487761
                        )
                      }),
                      _c(
                        "div",
                        { staticClass: "text-right" },
                        [
                          _c(
                            "a-button",
                            {
                              class: _vm.$style.filledBtn,
                              attrs: {
                                type: "primary",
                                autoInsertSpaceInButton: "false"
                              },
                              on: { click: _vm.outputCSV }
                            },
                            [_vm._v("CSV出力")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "utils__title mb-3" }, [
      _c("strong", { staticClass: "text-uppercase font-size-16" }, [
        _vm._v("点呼代行回数履歴")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h2", [_vm._v("現在の代行回数設定")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h2", [_vm._v("点呼代行回数履歴")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }